import { adminHttpClient } from '../../commons/adminHttpClient'

const deleteFamilyMemberInsurancePolicy = (id: string) => {
  return adminHttpClient.delete('Expenses/DeleteFamilyMemberInsurancePolicy', {
    data: { policyId: id },
  })
}

export default deleteFamilyMemberInsurancePolicy
